import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { FlagValidator } from 'src/app/shared/enumeraciones/flag-validator.enum';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { AnotacionAdminNacionalEntry } from 'src/app/shared/entrys/anotacion-admin-nacional.entry';


@Injectable({
	providedIn: 'root'
})
export class AdministradorAnotacionesService implements RequestCRUD<AnotacionAdminNacionalEntry, ResponseServiceModel> {
	
	private API_URL:string;
	private handleError: HandleError;

	constructor(private http: HttpClient, 
		protected httpErrorHandler: HttpErrorHandler, 
		protected enviromentGlobalService: EnviromentGlobalService) 
	{
		this.handleError = httpErrorHandler.createHandleError('SolicitudesService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	public getCamarasDeComercio(): Observable<ResponseServiceModel> {
		return this.http
			.get<ResponseServiceModel>(`${this.API_URL}/CamaraComercio`)
			.pipe(retry(2));
	}

	
	public getAnotaciones(numeroPagina: number, filtroRequest: any): Observable<ResponseServiceModel> {
		return this.http
			.post<ResponseServiceModel>(`${this.API_URL}/AnotacionAdministrador?PageNumber=${numeroPagina}&PageSize=12&QueryType=${FlagValidator.Todos}`, filtroRequest)
			.pipe(retry(2));
	}
	
	public update(anotacion: AnotacionAdminNacionalEntry): Observable<ResponseServiceModel> {
		return this.http
			.put<ResponseServiceModel>(`${this.API_URL}/AnotacionAdministrador/${anotacion.anotacionId}`, {activo: anotacion.activo})
			.pipe(retry(2));
	}

	get(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	public create(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	public delete(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
}